import React from "react";
import { useForm } from "react-final-form";
import { gql } from "@apollo/client";
import { Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import {
  InstrumentTypeSelectField,
  MaterialColorSelectField,
  MouthpieceTipOpeningSelectField,
  MouthpieceTipOpening,
} from "@syos-music/instruments";

import { Grid, FormControlLabel, Checkbox } from "@mui/material";

import SignatureMouthpieceSelectField from "components/signatureMouthpiece/SignatureMouthpieceSelectField";

const SIGNATURE_MOUTHPIECE_FRAGMENT = gql`
  fragment OptionsField_SignatureSaxophoneMouthpiece on SignatureMouthpiece {
    id
    signature
    mouthpieceColor
    ligatureColor

    mouthpieceRef {
      id
      instrumentType

      saxophoneMouthpiece {
        id
        tipOpening
      }
    }
  }
`;

export default function OptionsField({ name }) {
  const form = useForm();

  const saxophoneType = form.getFieldState(`${name}.saxophoneType`)?.value;

  const signatureMouthpieceSelectRef = React.useRef();
  const [autoUpdate, setAutoUpdate] = React.useState(false);

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <Field name={`${name}.signature`} component="input" type="hidden" />

        <SignatureMouthpieceSelectField
          filters={{ instrument: ["saxophone"] }}
          name={`${name}.signatureMouthpieceId`}
          required
          ref={signatureMouthpieceSelectRef}
          fragment={SIGNATURE_MOUTHPIECE_FRAGMENT}
        />

        <OnChange name={`${name}.signatureMouthpieceId`}>
          {() => {
            const { signatureMouthpiece } =
              signatureMouthpieceSelectRef.current;

            form.change(`${name}.signature`, signatureMouthpiece.signature);

            if (!autoUpdate) return;

            const saxophoneType =
              signatureMouthpiece.mouthpieceRef?.instrumentType;
            const tipOpening = MouthpieceTipOpening.fromMilimeters(
              "saxophone",
              saxophoneType,
              signatureMouthpiece.mouthpieceRef?.saxophoneMouthpiece
                ?.tipOpening / 100
            )?.key;

            form.change(`${name}.saxophoneType`, saxophoneType);
            form.change(`${name}.tipOpening`, tipOpening);
            form.change(
              `${name}.mouthpieceColor`,
              signatureMouthpiece.mouthpieceColor
            );
            form.change(
              `${name}.ligatureColor`,
              signatureMouthpiece.ligatureColor
            );
          }}
        </OnChange>

        <FormControlLabel
          control={
            <Checkbox
              checked={autoUpdate}
              onChange={(evt, checked) => setAutoUpdate(checked)}
            />
          }
          label="Mise à jour auto"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <InstrumentTypeSelectField
          instrument="saxophone"
          name={`${name}.saxophoneType`}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MouthpieceTipOpeningSelectField
          name={`${name}.tipOpening`}
          instrument="saxophone"
          instrumentType={saxophoneType}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField
          name={`${name}.mouthpieceColor`}
          allowPrivate
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField name={`${name}.ligatureColor`} allowPrivate />
      </Grid>
    </Grid>
  );
}
